import { createContext } from 'react';

export const AuthContext = createContext();
export const Auth2Context = createContext();
